var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../../../classes/runtime/Runtime';
let SvgFilterDefs = class SvgFilterDefs extends React.PureComponent {
    render() {
        const { aspect } = this.props;
        if (!runtime.streamedPackages.Exotic)
            return null;
        /*
        SVG filter playground: https://yoksel.github.io/svg-filters/#/
         */
        return (React.createElement("defs", null, aspect.activesOf.svgFilterDef.map(at => (React.createElement("filter", { id: at.trait.value, x: at.trait.local.valueOf.x || '-50%', y: at.trait.local.valueOf.y || '-50%', width: at.trait.local.valueOf.width || '200%', height: at.trait.local.valueOf.height || '200%' },
            at.trait.activesOf.feDropShadow.map(at2 => (React.createElement("feDropShadow", { key: at2.id, dx: at2.trait.local.valueOf.dx, dy: at2.trait.local.valueOf.dy, stdDeviation: at2.trait.local.valueOf.stdDeviation, floodColor: at2.trait.local.valueOf.floodColor }))),
            at.trait.activesOf.feGaussianBlur.map(at2 => (React.createElement("feGaussianBlur", { key: at2.id, stdDeviation: at2.trait.local.valueOf.stdDeviation, edgeMode: at2.trait.local.valueOf.floodColor, in: at2.trait.local.valueOf.svgFilterDefIn }))))))));
    }
};
SvgFilterDefs = __decorate([
    observer
], SvgFilterDefs);
export { SvgFilterDefs };
